import { Component, ChangeDetectionStrategy } from '@angular/core'
import { NgOptimizedImage } from '@angular/common'
import { RouterLink } from '@angular/router'

@Component({
  selector: 'bo-main-logo',
  templateUrl: './main-logo.html',
  styleUrls: ['./main-logo.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, NgOptimizedImage],
})
export class MainLogo {
  public imgPath = '/assets/images/logos/logo-performance.svg'
}
